import { EditPresetComponent } from './edit-preset.component';
import { connect } from 'react-redux';
import { AppState } from '../../app.state';
import { updatePresets } from '../dashboard.actions';

export const EditPreset = connect(
  (state: AppState) => ({ sState: state }),
  { updatePresets }
)(EditPresetComponent as any) as unknown as typeof EditPresetComponent;
